import { useMemo } from "react";
import clsx from "clsx";
import { SignalIcon } from "@/shared/icons";

type Props = {
  latency: number;
  className?: string;
};

export default function HudPing({ latency, className }: Props) {
  const percent = useMemo(() => {
    if (latency < 40) return 100;
    if (latency < 100) return 75;
    if (latency < 200) return 50;
    return 0;
  }, [latency]);

  return (
    <div className={clsx("flex items-center gap-2", className)}>
      <div className="relative w-3.5 aspect-square">
        <SignalIcon size={14} className="text-white/50 absolute" />
        <SignalIcon
          size={14}
          className="text-white absolute"
          style={{
            clipPath: `polygon(0% 0%, ${percent}% 0%, ${percent}% 100%, 0% 100%)`,
          }}
        />
      </div>
      <div className="font-bold text-12 text-white/70">
        PING: <span className="text-white">{latency}ms</span>
      </div>
    </div>
  );
}
